<template>
    <div>
        <h5>Informations supplémentaires</h5>

        <b-form-textarea id="textarea" v-model="extra_infos" placeholder="Enter something..." rows="3"
            max-rows="6"></b-form-textarea>
        <b-button class="inline-submenu-btn with_icon" icon="save" @click="saveExtraInfos">Enregistrer</b-button>
    </div>
</template>

<script>
import axios from "axios";
export default {
    props: {
        coureur: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            extra_infos: ""
        }
    },
    mounted() {

        this.fetchExtraInfos();
    },
    methods: {
        saveExtraInfos() {
            axios.post(this.$store.state.base_url + "/pc_course/extra_infos/post.php", {
                id_live: this.coureur.id_live,
                id_coureur: this.coureur.id,
                extra_infos: this.extra_infos
            });
        },
        fetchExtraInfos() {
            axios.get(this.$store.state.base_url + "/pc_course/extra_infos/get.php", {
                params: {
                    id_live: this.coureur.id_live,
                    id_coureur: this.coureur.id,
                }
            }).then(response => {

                this.extra_infos = response.data.extra_infos_pc_course;
            });
        }
    }

}
</script>

<style lang="scss" scoped></style>